import { initI18n } from '@referee/i18n';
import { loginLocaleEn, loginLocaleDe } from '@semsis/auth-frontend';
import loginLocaleEs from './locales/login-es.json';
import loginLocalePt from './locales/login-pt.json';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

const i18n = initI18n({
  resources: {
    en: { translation: { ...loginLocaleEn, ...en } },
    de: { translation: { ...loginLocaleDe, ...de } },
    es: { translation: { ...loginLocaleEs, ...es } },
    pt: { translation: { ...loginLocalePt, ...pt } },
  },
  supportedLngs: ['en', 'de', 'es', 'pt'],
});

export default i18n;
